import { StaticBaseDao } from '@/dao';
import { GroupWithCount } from '@/objects/generated';

export class GroupDao extends StaticBaseDao {
    public static async GroupsWithCount(EventID: number, uids?: number[], detailed?: boolean): Promise<GroupWithCount[]> {
        return this.BaseFetchArray(
            GroupWithCount,
            `Group/GroupsWithCount` +
                '?' +
                (EventID == undefined ? '' : `EventID=${EventID}`) +
                '&' +
                (uids == undefined ? '' : `${this.makeGetStringFromList(uids, 'uids')}`) +
                '&' +
                (detailed == undefined ? '' : `detailed=${detailed}`),
            'GET',
        );
    }
}
